export default __webpack_public_path__ + "static/media/element_89.e69e82eb.webp";